<div>
  <div class="flex flex-row">
    <div class="button-container flex flex-row justify-start items-center">
      <button mat-button class="action-button" (click)="onDownload(translationModel.leftFile.fileType)">Download
        ({{translationModel.leftFile.fileType}})
      </button>
    </div>
  </div>
</div>

<!--

<div *ngIf="isDocSelected">
  <div fxLayout="row">
    <div class="button-container" fxLayout="row" fxLayoutAlign="start center">
      <button mat-button class="action-button" (click)="onDownload(translationFileType.Pdf)"
      &gt;Download (PDF)
      </button>
    </div>
    <div class="toolbar-separator m-lr-10"></div>
    <div class="button-container" fxLayout="row" fxLayoutAlign="start center">
      <button mat-button class="action-button" (click)="onDownload(translationFileType.Doc)"
      &gt;Download (DOC)
      </button>
    </div>
  </div>
</div>
-->
